import React from "react";
import Image from "../../assets/image/png/shipping-policy.png";
const ShippingPolicyHero = () => {
  return (
    <div className="pb-4">
      <div className="position-relative">
        <img
          height={300}
          className="w-100 obj-fit" 
          src={Image}
          alt="contact_us_image"
        />
        <div className="position-absolute w-100 text-center  tranform_m1">
          <h4 className=" fs_48 ff_raleway fw-bold text-white">
            Shipping Policy
          </h4>
        </div>
      </div>
    </div>
  );
};

export default ShippingPolicyHero;
